<style>
.refresh-btn:hover {
  color: white !important;
}

.refresh-btn:hover .icon {
  color: white !important;
}

.refresh-btn:hover span {
  color: white !important;
}
</style>

<div class="tab-content">
  <div class="page-title">
    <span translate>TIME_TABLE</span>
    <span class="page-actions pull-right"> </span>
  </div>
  
  <div class="table-view">
    <!-- Table starts -->
    <p-table
      #timetableTable
      [value]="timetables"
      [rows]="pageSize"
      [paginator]="true"
      [pageLinks]="3"
      [lazy]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [totalRecords]="totalItems"
      [first]="first"
      (onPage)="onPageChange($event)"
      (onSort)="onSort($event)"
      [loading]="isLoading"
      dataKey="Id"
      [(selection)]="selectedTimetable"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
    >
      <!-- Caption -->
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <div class="filter-controls-wrapper" style="display: none">
            <form [formGroup]="TimetableForm">
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="Month" class="col-form-label">
                      <span translate>MONTH</span>
                    </label>
                    <div>
                      <p-select
                        [options]="months"
                        (onChange)="onMonthChanged($event, m)"
                        #m
                        formControlName="Month"
                        [style]="{ width: '160px' }"
                      >
                      </p-select>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="Year" class="col-form-label">
                      <span translate>YEAR</span>
                    </label>
                    <div>
                      <p-select
                        type="text"
                        [options]="years"
                        (onChange)="onYearChanged($event, y)"
                        #y
                        formControlName="Year"
                        [style]="{ width: '160px' }"
                      >
                      </p-select>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="department" class="col-form-label">
                      <span translate>FROM_DATE</span>
                    </label>
                    <div>
                      <p-datepicker
                        name="FromDate"
                        formControlName="FromDate"
                        [placeholder]="'ENTER_THE_START_DATE' | translate"
                        [showIcon]="true"
                        [dateFormat]="'dd/mm/yy'"
                        (onSelect)="onTimeTableStartDateChanged($event)"
                      ></p-datepicker>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="department" class="col-form-label">
                      <span translate>END_DATE</span>
                    </label>
                    <div>
                      <p-datepicker
                        name="EndDate"
                        formControlName="EndDate"
                        [placeholder]="'ENTER_STOP_DATE' | translate"
                        [showIcon]="true"
                        [dateFormat]="'dd/mm/yy'"
                        (onSelect)="onTimeTableEndDateChanged($event)"
                        required
                      ></p-datepicker>
                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>
          <div class="table-options">
            <div class="pull-left">
              <div class="action-btns-group">
                <button
                  class="btn btn-outline-primary refresh-btn"
                  type="button"
                  (click)="refreshTable()"
                >
                  <span class="icon ic-sm icon-reset"></span>
                  <span translate>REFRESH</span>
                </button>
              </div>
            </div>
            <div class="pull-right">
              <div class="action-btns-group">
                <button class="btn p-3 filter-toggle">
                  <span class="icon ic-sm icon-filter"></span>
                  <span translate>FILTER</span>
                </button>
              </div>
              <div class="action-btns-group">
                <div class="dropdown">
                  <a href="javascript:void(0);" class="btn p-3 toggle-action-btn" [class.disabled]="isLoading">
                    <i class="pi pi-download"></i>
                    <span translate>EXPORT</span>
                  </a>
                  <div class="export-btns">
                    <button 
                      type="button" 
                      class="dropdown-item" 
                      (click)="exportTimetables('XLSX')"
                      [disabled]="isLoading"
                    >
                      <i class="icon ic-sm icon-xls mr-2"></i>
                      <span translate>EXCEL</span>
                    </button>
                    <button 
                      type="button" 
                      class="dropdown-item" 
                      (click)="exportTimetables('DOCX')"
                      [disabled]="isLoading"
                    >
                      <i class="icon ic-sm icon-word mr-2"></i>
                      <span translate>WORD</span>
                    </button>
                    <button 
                      type="button" 
                      class="dropdown-item" 
                      (click)="exportTimetables('PDF')"
                      [disabled]="isLoading"
                    >
                      <i class="icon ic-sm icon-pdf mr-2"></i>
                      <span translate>PDF</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 55px" *ngIf="isApproveTimetable">
            <p-tableHeaderCheckbox
              (click)="onHeaderCheckboxClick()"
            ></p-tableHeaderCheckbox>
          </th>

          <th pSortableColumn="ProjectWorkTypeName">
            {{ "TYPE_OF_WORK" | translate }}
            <p-sortIcon field="ProjectWorkTypeName"></p-sortIcon>
          </th>
          <th pSortableColumn="EmployeeName">
            {{ "EMPLOYEE_NAME" | translate }}
            <p-sortIcon field="EmployeeName"></p-sortIcon>
          </th>
          <th pSortableColumn="ProjectName">
            {{ "ORIGIN" | translate }}
            <p-sortIcon field="ProjectName"></p-sortIcon>
          </th>
          <th pSortableColumn="StartDate" width="94px">
            {{ "START_DATE" | translate }}
            <p-sortIcon field="StartDate"></p-sortIcon>
          </th>
          <th pSortableColumn="EndDate" width="94px">
            {{ "END_DATE" | translate }}
            <p-sortIcon field="EndDate"></p-sortIcon>
          </th>
          <th pSortableColumn="StartTime" width="94px">
            {{ "START_TIME" | translate }}
            <p-sortIcon field="StartTime"></p-sortIcon>
          </th>
          <th pSortableColumn="EndTime" width="94px">
            {{ "END_TIME" | translate }}
            <p-sortIcon field="EndTime"></p-sortIcon>
          </th>
          <th pSortableColumn="BreakTime" width="74px">
            {{ "Break" | translate }}
            <p-sortIcon field="BreakTime"></p-sortIcon>
          </th>
          <th pSortableColumn="HoursSpent" width="84px">
            {{ "TOTAL_HOURS_SPENT" | translate }}
            <p-sortIcon field="HoursSpent"></p-sortIcon>
          </th>
          <th>
            {{ "APPROVAL_PERSON" | translate }}
          </th>
          <th width="74px">{{ "STATUS" | translate }}</th>
          <th *ngIf="isUser" width="55px"></th>
        </tr>
        <tr [formGroup]="filterForm">
          <th *ngIf="isApproveTimetable" width="36px"></th>
          <th>
            <input
              pInputText
              type="text"
              formControlName="workType"
              (input)="onWorkTypeFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              formControlName="employeeName"
              (input)="onEmployeeNameFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              formControlName="origin"
              (input)="onOriginFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>
            <input
              pInputText
              type="text"
              formControlName="approverName"
              (input)="onApproverNameFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th>
            <p-select
              [options]="statusList"
              (onChange)="onStatusChanged($event, statusDropdown)"
              #statusDropdown
              formControlName="status"
              [style]="{ width: '100%' }"
              [showClear]="true"
            >
            </p-select>
          </th>
          <th *ngIf="isUser"></th>
        </tr>
      </ng-template>
      <!-- Body Content -->
      <ng-template pTemplate="body" let-employeeTimetable let-object="rowData">
        <tr>
          <td style="width: 55px" *ngIf="isApproveTimetable">
            <p-tableCheckbox id="selectedOrders" [value]="employeeTimetable">
            </p-tableCheckbox>
          </td>
          <td>
            <span>
              <a [routerLink]="['../../edit', employeeTimetable.Id]">{{
                employeeTimetable.ProjectWorkTypeName
              }}</a>
            </span>
          </td>
          <td>
            <div
              pTooltip="{{ employeeTimetable.EmployeeName }}"
              tooltipPosition="top"
            >
              {{ employeeTimetable.EmployeeName }}
            </div>
          </td>
          <td>
            <span
              pTooltip="{{ employeeTimetable.ProjectName }}"
              tooltipPosition="top"
              >{{ employeeTimetable.ProjectName }}</span
            >
          </td>
          <td>
            <span pTooltip="{{ employeeTimetable.StartDate | date: 'dd/MM/yyyy' }}">{{
              employeeTimetable.StartDate | date: 'dd/MM/yyyy'
            }}</span>
          </td>
          <td>
            <span pTooltip="{{ employeeTimetable.EndDate | date: 'dd/MM/yyyy' }}">{{
              employeeTimetable.EndDate | date: 'dd/MM/yyyy'
            }}</span>
          </td>
          <td>
            <span>{{ employeeTimetable.StartTime | slice:0:5 }}</span>
          </td>
          <td>
            <span>{{ employeeTimetable.EndTime | slice:0:5 }}</span>
          </td>
          <td>
            <span>{{ employeeTimetable.BreakTime | slice:0:5 }}</span>
          </td>
          <td>
            <span>{{ employeeTimetable.HoursSpent | slice:0:5 }}</span>
          </td>
          <td>
            <span>{{ employeeTimetable.ApproverNameListString || (employeeTimetable.ApproverNameList ? employeeTimetable.ApproverNameList.join(', ') : '') }}</span>
          </td>
          <td>
            <span>{{ employeeTimetable.StatusText | translate }}</span>
          </td>
          <td class="col-button" *ngIf="isUser">
            <button
              type="button"
              title="{{ 'DELETE' | translate }}"
              (click)="deleteTimetable(employeeTimetable.Id)"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
          </td>
        </tr>
      </ng-template>
      <!-- Empty message -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td colspan="12">
            {{ "NO_RECORDS_FOUND" | translate }}
          </td>
        </tr>
      </ng-template>
      <!-- footerColumnGroup -->
      <ng-template pTemplate="groupheader" let-customer>
        <tr pRowGroupHeader>
          <td
            colspan="7"
            [style]="{ 'text-align': 'right', 'font-weight': 'bold' }"
          >
            {{ "TOTAL_HOURS_SPENT" | translate }}:
          </td>
          <td [style]="{ 'text-align': 'left', 'font-weight': 'bold' }">
            {{ totalHoursSpent }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- Table ends -->
    <div class="action-btns-wrapper">
      <button
        class="btn btn-primary"
        type="submit"
        (click)="approveMultiple(selectedTimetable)"
      >
        <span translate>APPROVE_SELECTED</span>
      </button>
    </div>
  </div>
  <p-confirmDialog
    header="{{ 'CONFIRMATION' | translate }}"
    icon="pi pi-question-circle"
    width="425"
    acceptLabel="{{ 'SWITCH_YES' | translate }}"
    rejectLabel="{{ 'SWITCH_NO' | translate }}"
  ></p-confirmDialog>
</div>

<p-dialog
  [(visible)]="isTimeTableSelected"
  [style]="{ width: '500px' }"
  [resizable]="false"
  [draggable]="false"
>
  <span translate>SELECT_ONE_TIMETABLE</span>
</p-dialog>

